"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroupProvider = exports.ToolbarProvider = undefined;
exports.useToolbarContext = useToolbarContext;
exports.useButtonGroupContext = useButtonGroupContext;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ToolbarContext = (0, _react.createContext)(null);
var ButtonGroupContext = (0, _react.createContext)(null);

var ToolbarProvider = exports.ToolbarProvider = function ToolbarProvider(_ref) {
  var children = _ref.children,
      testId = _ref.testId;
  return _react2.default.createElement(ToolbarContext.Provider, {
    value: {
      testId: testId
    }
  }, children);
};

var ButtonGroupProvider = exports.ButtonGroupProvider = function ButtonGroupProvider(_ref2) {
  var children = _ref2.children,
      testId = _ref2.testId;
  return _react2.default.createElement(ButtonGroupContext.Provider, {
    value: {
      testId: testId
    }
  }, children);
};

function useToolbarContext() {
  var context = (0, _react.useContext)(ToolbarContext);

  if (!context) {
    throw new Error('Do not use Toolbar composites outside of context');
  }

  return context;
}

function useButtonGroupContext() {
  var context = (0, _react.useContext)(ButtonGroupContext);

  if (!context) {
    throw new Error('Do not use ButtonGroup composites outside of context');
  }

  return context;
}